import {platformedClient} from "..";

export async function list() {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/deals`, {});
}
